export function formatStatsComparisonData(data) {
  if (isObjectEmpty(data) && !data?.hasOwnProperty('match_statistics_list')) {
    return [null, null];
  }

  if (!(Array.isArray(data.match_statistics_list) && data.match_statistics_list.length)) {
    return [null, null];
  }
  
  const teamsData = data.match_statistics_list[0]?.match_statistics?.team_statistics;
  
  if (!teamsData || teamsData.length !== 2) {
    return [null, null];
  }

  return teamsData.map(club => {
    const {
      goals,
      shots_at_goal_wide: shot_off_target,
      shots_on_target: ontarget_scoring_att,
      shots_at_goal_blocked: blocked_scoring_att,
      team_role,
      three_letter_code,
      team_three_letter_code,
      team_name: fullName
    } = club || {};

    return {
      goals: goals || 0,
      shot_off_target: shot_off_target || 0,
      ontarget_scoring_att: ontarget_scoring_att || 0,
      blocked_scoring_att: blocked_scoring_att || 0,
      team_role,
      abbreviation: team_three_letter_code || three_letter_code || '',
      fullName: fullName || ''
    };
  });
}

export function isObjectEmpty(obj = {}) {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}